import {useRef, useState} from "react";

import {LeasePackageCatalogSummaryDto} from "../../model/LeasePackageCatalog";
import {customAxios} from "../customAxios";

export function useGetTenantLeasePackageCatalogs() {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<LeasePackageCatalogSummaryDto[]>();
    const [error, setError] = useState<Error>();
    const latestRequest = useRef(0);

    async function execute(tenantId: number) {
        const request = ++latestRequest.current;
        try {
            setLoading(true);
            setError(undefined);
            const catalogs = await getTenantLeasePackageCatalogs(tenantId);
            if(request === latestRequest.current) setData(catalogs);
            return catalogs;
        } catch (e) {
            if(request === latestRequest.current) setError(e as Error);
            return Promise.reject(e);
        } finally {
            if(request === latestRequest.current) setLoading(false);
        }
    }

    return {loading, data, error, execute};
}

export async function getTenantLeasePackageCatalogs(
    tenantId: number,
): Promise<LeasePackageCatalogSummaryDto[]> {
    const response = await customAxios.get<LeasePackageCatalogSummaryDto[]>(
        `/v1/tenant/${tenantId}/lease-package-catalogs`,
    );
    return response.data;
}
